<template lang="html">
  <div class="">
    <toolBar></toolBar>
    <gallery></gallery>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { store } from '../store/store'

export default {

  name: 'demodrilldown',
  data(){
    return{
      returnedData: {}
    }
  },
  methods: {
    ...mapActions([
      'retrieveMatchedImages',
      'setSearchTerm',
      'resetCurrentIndex'
    ])
  },
  computed: {
    ...mapGetters([
      'getMatchedImages',
      'getSearchTerm'
    ])
  },
  beforeRouteEnter( to, from, next) {
      store.dispatch('retrieveMatchedImages', {result: to.params.tags, thumbnail: false})
      .then(() => {
        next()
      })
      .catch((err) => {
        console.warn(err);
      })
  },
  created(){
    window.scrollTo(0,0);
    const tag = this.$router.history.current.params.tags;
    if(this.$router.history.current.params.tags !== this.getSearchTerm) {
      store.dispatch('setSearchTerm', tag)
    }
    store.dispatch('resetCurrentIndex')
  }
}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/demoDrillDown.vue